import "./Channel.scss";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import queryString from "querystring";

import { Button, Input, Spin } from "antd";

import partnersApi from "../../apis/Partners.api";
import { toastAlert } from "../../components/AlertComponent";
import ChannelCommentComponent from "../../components/channel/comment/ChannelCommentComponent";
import ProductPuchaseComponent from "../../components/channel/ProductPuchaseComponent";
import { setLoading } from "../../redux/store/common/commonDuck";

const CombinationsId = (props) => {
	const combinationId = props.match?.params?.id;
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);

	const [detail, setDetail] = useState({});
	const dispatch = useDispatch();

	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [second, setSecond] = useState(0);

	const bgCombination = ["#A3D27A", "#719C4A", "#7AD629", "#3E7D08"];
	const queryJson = queryString.parse(
		history.location.search?.replace("?", "")
	);
	const channelId = queryJson?.id;

	useEffect(() => {
		setSecond((Math.random() * 10).toFixed() % 4);
	}, []);

	useEffect(() => {
		if (detail.id) {
			updateView();
		}
	}, [detail]);

	const updateView = async () => {
		const param = {
			category_name: "combination",
			updated_by: cUser?.id ?? 0,
			id: detail?.id,
			influencer_id: reduxChannel?.user_id,
		};
		await partnersApi.updatePageViewNum(param);
	};

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
		// if (!history.location.pathname.includes("?id") && reduxChannel?.influencer_id) {
		//     history.replace(`?id=${reduxChannel?.influencer_id}`)
		// }
		if (!channelId && reduxChannel?.influencer_id) {
			if (channelId !== reduxChannel.influencer_id) {
				history.replace(history.location.pathname + history.location.search);
			}
			// else {
			//     if (isLoading) {
			//         setIsLoading(false);
			//     }
			// }
		}
		if (reduxChannel?.user_id) {
			getCategory();
		}
	}, [reduxChannel]);

	/**
	 * 해당 카테고리 가져오기
	 * @returns {Promise<void>}
	 */
	const getCategory = async () => {
		setIsLoading(true);
		let param = {
			combinationId: combinationId,
			categoryType: "combination",
			influencerId: reduxChannel?.user_id,
		};
		const res = await partnersApi.togetherCategoryDetail(param);
		if (res.code) {
			if (res.code === 200) {
				setDetail(res.result);
			} else {
				// history.replace(`/404`)
			}
		}
		setIsLoading(false);
	};

	const handleCopyLink = (e) => {
		window.navigator.clipboard.writeText(e.currentTarget.value).then(() => {
			toastAlert("코드 복사가 완료 되었습니다.");
		});
	};

	return (
		<div className="channel-home">
			<div className={`home-header`}>
				<div
					className={`home-title-div product-title`}
					style={{
						background: `${
							reduxChannel?.color_1
								? reduxChannel?.color_1
								: bgCombination[second]
						} no-repeat right / auto 100% url("${
							process.env.REACT_APP_HOST
						}/assets/images/channel/channel-bg-0.png")`,
					}}
				>
					<div className={`max-width-apply`}>
						<h1 className={`home-title`}>{detail?.category_name}</h1>
						{/*<p>*/}
						{/*    {detail?.tag}*/}
						{/*</p>*/}

						<div
							id={`combination-tag`}
							dangerouslySetInnerHTML={{
								__html: detail.reason,
							}}
						/>
					</div>
				</div>
			</div>
			<div className={`home-body`} style={{ gap: 0 }}>
				{isLoading ? (
					<Spin style={{ margin: "auto", width: "100%", paddingTop: "2em" }} />
				) : (
					<div className={`max-width-apply`}>
						<div className={`product-body`}>
							{/*/!* 조합 추천 이유*!/*/}
							{/*{detail?.reason && (*/}
							{/*    <div className={`product-each caution-div`}>*/}
							{/*        <h3 className={`body-title`}>*/}
							{/*            조합 추천 이유*/}
							{/*        </h3>*/}
							{/*        <p*/}
							{/*            dangerouslySetInnerHTML={{*/}
							{/*                __html: detail.reason*/}
							{/*            }}/>*/}
							{/*    </div>*/}
							{/*)}*/}

							{/* 관련 영상 보기 */}
							{detail?.associatedVideoList?.length > 0 && (
								<div className={`product-each order-end`}>
									<h3 className={`body-title`}>관련 영상 보기</h3>
									<div className={`youtube-group`}>
										{detail.associatedVideoList?.map((item, idx) => (
											<button
												className={`youtube-each`}
												key={`관련 영상 보기 ${idx}`}
												onClick={() => {
													window.open(item?.url);
												}}
											>
												<img
													src={`/assets/images/channel/${
														item?.url.includes("instagram")
															? "instagram"
															: "youtube"
													}.png`}
													alt={`관련영상`}
													style={{
														width: "auto",
														height: "1.5em",
													}}
												/>
												<span>{item?.title}</span>
											</button>
										))}
									</div>
								</div>
							)}

							{/* 관련 영양제 */}
							{detail?.productList?.length > 0 && (
								<div className={`product-each`}>
									<h3 className={`body-title`}>관련 영양제</h3>
									{/*<h3 className={`body-title`}>*/}
									{/*    관련 영양제*/}
									{/*</h3>*/}
									{/*{detail?.productListByCategory?.map((category, index) => (*/}
									{/*    <div key={`관련 영양제 카테고리 ${index}`}>*/}
									{/*        <h3 className={`body-title`} style={{padding: "1em 0"}}>*/}
									{/*            {index + 1}. {category.category_name}*/}
									{/*        </h3>*/}
									{/*        {category?.productList?.map((item, idx) => (*/}
									{/*            <div className={`product-recommend-each`} key={`관련 영양제 ${idx}`}>*/}
									{/*                <div className={`product-recommend-group`}>*/}
									{/*                    <div className={`product-recommend-image-div`}>*/}
									{/*                        <img*/}
									{/*                            src={`${process.env.REACT_APP_S3_HOST}/image/together/${reduxChannel?.influencer_id}/${item?.id}.${item?.img_type}`}*/}
									{/*                            onError={({currentTarget}) => {*/}
									{/*                                currentTarget.onerror = null; // prevents looping*/}
									{/*                                // currentTarget.style.display = "none";*/}
									{/*                                currentTarget.src = `/assets/images/no-product.png`;*/}
									{/*                            }}*/}
									{/*                            alt={`영양제 이미지`}*/}
									{/*                            className={`product-recommend-image`}*/}
									{/*                        />*/}
									{/*                    </div>*/}
									{/*                    <div className={`product-description`}>*/}
									{/*                        <p className={`product-brand-name`}>*/}
									{/*                            {item?.brand_name}*/}
									{/*                        </p>*/}
									{/*                        <p className={`product-name`}>*/}
									{/*                            {item?.product_name}*/}
									{/*                        </p>*/}
									{/*                        <p className={`product-sub`}>*/}
									{/*                            {item?.sub_title}*/}
									{/*                        </p>*/}
									{/*                        <div className={`product-list`}>*/}
									{/*                            {Array.from({length: 6}).map((arr, idx) => {*/}
									{/*                                let column = `description` + (idx + 1);*/}
									{/*                                if (item[column]) {*/}
									{/*                                    return (*/}
									{/*                                        <div className={`product-list-each`}*/}
									{/*                                             key={`상품 설명 ${idx}`}>*/}
									{/*                                            <p className={`list-num`}>*/}
									{/*                                                0{idx + 1}*/}
									{/*                                            </p>*/}
									{/*                                            <p>*/}
									{/*                                                {item[column]}*/}
									{/*                                            </p>*/}
									{/*                                        </div>*/}
									{/*                                    )*/}
									{/*                                } else {*/}
									{/*                                    return <></>*/}
									{/*                                }*/}
									{/*                            })}*/}
									{/*                        </div>*/}
									{/*                        {item?.purchaseLinkList?.map((item, idx) => (*/}
									{/*                            <div key={`구매 링크 할인 코드 ${idx}`}>*/}
									{/*                                {item?.discount_code && (*/}
									{/*                                    <div className={`product-discount-code-wrap`}>*/}
									{/*                                        <p>{item?.platform_name} 할인 코드</p>*/}
									{/*                                        <div className={`discount-code-div`}>*/}
									{/*                                            <div className={`discount-code`}>*/}
									{/*                                                <span>{item.discount_code}</span>*/}
									{/*                                            </div>*/}
									{/*                                            <Button*/}
									{/*                                                className={`discount-copy`}*/}
									{/*                                                value={item.discount_code}*/}
									{/*                                                onClick={handleCopyLink}*/}
									{/*                                            >*/}
									{/*                                                <img*/}
									{/*                                                    src={`/assets/images/channel/link-copy.png`}*/}
									{/*                                                    alt={`링크 생성`}*/}
									{/*                                                    height={12}*/}
									{/*                                                />*/}
									{/*                                                코드복사*/}
									{/*                                            </Button>*/}
									{/*                                        </div>*/}
									{/*                                    </div>*/}
									{/*                                )}*/}
									{/*                            </div>*/}
									{/*                        ))}*/}
									{/*                    </div>*/}
									{/*                </div>*/}
									{/*                {item?.purchaseLinkList?.length > 0 ? (*/}
									{/*                    <>*/}
									{/*                        {item?.purchaseLinkList?.map((link, idx) => (*/}
									{/*                            <div key={`구매 링크 ${idx}`}>*/}
									{/*                                {link?.url && (*/}
									{/*                                    <button*/}
									{/*                                        className={`product-purchase`}*/}
									{/*                                        style={{width: "100%"}}*/}
									{/*                                        onClick={() => {*/}
									{/*                                            window.open(link?.url);*/}
									{/*                                        }}*/}
									{/*                                    >*/}
									{/*                                        {link.platform_name === "당신의 영양제" ? "" : `${link.platform_name} `}구매하기*/}
									{/*                                    </button>*/}
									{/*                                )}*/}
									{/*                            </div>*/}
									{/*                        ))}*/}
									{/*                    </>*/}
									{/*                ) : (*/}
									{/*                    <button*/}
									{/*                        className={`product-purchase gray`}*/}
									{/*                        style={{width: "100%"}}>*/}
									{/*                        약국에서 구매가 가능한 상품입니다.*/}
									{/*                    </button>*/}
									{/*                )}*/}
									{/*            </div>*/}
									{/*        ))}*/}
									{/*    </div>*/}
									{/*))}*/}
									<div className={`product-component-each`}>
										{detail?.productList?.map((item, index) => (
											<div
												key={`관련 조합 영양제 ${index}`}
												style={
													item?.purchaseLinkList?.length
														? {}
														: {
																display: "none",
														  }
												}
											>
												{item?.purchaseLinkList?.length > 0 ? (
													<>
														<ProductPuchaseComponent item={item} />
													</>
												) : (
													<></>
												)}
											</div>
										))}
									</div>
									<p className={`commission-notice`}>
										제공되는 당신의 영양제, 아이허브, 쿠팡, 셀로맥스 링크는 각
										파트너스 활동의 일환으로, 이에 따른 일정액의 수수료를
										제공받습니다. 리워드는 후원으로서 채널 운영에 활용됩니다.
										감사합니다.
										{/*제공되는 셀로맥스 스토어 링크를 통해 구매할 경우 링크 제공자에게 리워드가 지급됩니다. 리워드는 후원으로서 채널 운영에 활용됩니다. 감사합니다.*/}
									</p>
								</div>
							)}

							{/* 댓글 관리 */}
							{/*{reduxChannel?.user_id === 1 && detail?.is_comment_show && (*/}
							{detail?.is_comment_show && (
								<ChannelCommentComponent detail={detail} type={"combination"} />
							)}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
export default CombinationsId;
